import React from 'react'
import PropTypes from 'prop-types'

function JudgeBox({ judge, imgPath }) {
  return (
    <div className="col-12 judge-box">
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 judge-box__image">
          <img src={imgPath} alt={judge.name} />
        </div>
        <div className="col-12 col-md-6 col-lg-8 judge-box__info">
          <div className="judge-info__name u-mb10">{judge.name}</div>
          <div className="judge-info__title u-mb10">
            {judge.title} <a href={judge.url} target="_blank" className="link--primary-dark">{judge.company}</a>
          </div>
          <p dangerouslySetInnerHTML={{ __html: judge.description_html }} />
        </div>
      </div>
    </div>
  )
}

JudgeBox.propTypes = {
  judge: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    description_html: PropTypes.string.isRequired,
  }).isRequired,
  imgPath: PropTypes.string.isRequired,
}

export default JudgeBox
